import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

function getStripeKey() {
  if (typeof window === 'undefined') return undefined;
  return window?.serverData?.stripePublicKey;
}

const StripeContainer = ({ children }) => {
  const stripePublicKey = getStripeKey();

  const stripePromise = useMemo(() => {
    if (!stripePublicKey) return null;
    return loadStripe(stripePublicKey);
  }, [stripePublicKey]);

  if (!stripePublicKey || !stripePromise) return null;

  return <Elements stripe={stripePromise} children={children} />;
};

export default StripeContainer;
